import dayjs from "dayjs";

import {
  CabinClass,
  FlightsSortOptions,
  TripType,
  type FlightsSortValue,
} from "@/features/flights/types/types";
import type { FlightSearchFormInputValues } from "@/features/flights/utils/flightsValidation";
import { SortOrder } from "@/types/enums";

export const initialFlightSearchFormValues: FlightSearchFormInputValues = {
  tripType: TripType.ONE_WAY,
  from: null,
  to: null,
  dates: {
    departure: dayjs().add(1, "day").startOf("day").toDate(),
    return: dayjs().add(2, "day").startOf("day").toDate(),
  },
  cabinClass: CabinClass.ECONOMY,
  adult: 1,
  child: 0,
  infantWithoutSeat: 0,
};

export const initialSortValue: FlightsSortValue = {
  field: FlightsSortOptions.PRICE,
  order: SortOrder.ASC,
};
